import { render } from "./edit-dialog.vue?vue&type=template&id=2b09ca60&scoped=true"
import script from "./edit-dialog.vue?vue&type=script&lang=js"
export * from "./edit-dialog.vue?vue&type=script&lang=js"

import "./edit-dialog.vue?vue&type=style&index=0&id=2b09ca60&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b09ca60"]])

export default __exports__